<script setup lang="ts">
type Props = {
  length: number
  width: number | string
  height: number | string
  gap: number | string
  radius: number | string
}

const props = defineProps<Props>()

const skeletonStyles = computed(() => {
  return { gap: `${props.gap}px` }
})

const skeletonItemStyles = computed(() => {
  return {
    width: `${props.width}px`,
    height: `${props.height}px`,
    borderRadius: `${props.radius}px`,
  }
})
</script>

<template>
  <div class="app-skeleton-loader" :style="skeletonStyles">
    <div
      v-for="index in length"
      :key="index"
      :style="skeletonItemStyles"
      class="app-skeleton-loader__item"
    />
  </div>
</template>

<style lang="scss" scoped>
.app-skeleton-loader {
  display: flex;
  align-items: center;

  &__item {
    position: relative;
    flex-shrink: 0;
    overflow: hidden;
    background-color: var(--ui-grey);

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 3;
      content: '';
      background: linear-gradient(
        122.57deg,
        #f1f3f9 34.56%,
        #ffffff 51.72%,
        #f1f4f9 79.78%
      );
      background-size: 1200px 100%;
      animation: shimmer 3s linear infinite forwards;
    }
  }
}

@keyframes shimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}
</style>
